<template>
  <v-card
    class="mx-auto"
  >
    <v-card-text>
      <v-data-table dense v-if="!loading"
        :headers="tableHeader"
        :items="tableData"
        item-key="id"
        :items-per-page="pagination"
        :search="search"
        :custom-filter="filter"
        @click:row="goUpdateDetails"
      >
        <template v-slot:top>
        <div v-if="!hideToolbar">
        <v-row class="mx-auto ml-6">
          <v-col 
            style="max-width: 385px;">
          <v-datetime-picker 
            label="Από (Ημερομηνία)" 
            v-model="fromDateFilter" 
            :timePickerProps="timeOpts"
            dateFormat="dd-MM-yyyy" 
            timeFormat="HH:mm"
            pick12HourFormat="false"> 
            <template slot="dateIcon">
              <v-icon>mdi-calendar</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock</v-icon>
            </template>
          </v-datetime-picker>
          </v-col>

          <v-col
            style="max-width: 385px;" class="mx-auto ml-2">
          <v-datetime-picker 
            label="Έως (Ημερομηνία)" 
            v-model="toDateFilter" 
            :timePickerProps="timeOpts"
            dateFormat="dd-MM-yyyy" 
            timeFormat="HH:mm"> 
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
          </v-datetime-picker>
          </v-col>
        </v-row>

        <v-row justify-space-between class="mb-6">
        <!-- <v-text-field
          outline 
          max=30
          v-model="search"
          label="Αναζήτηση"
          class="ml-12"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="eventIdFilter"
          label="Χαρακτηριστικό Συμβάντος"
          class="ml-8"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="sensorIdFilter"
          label="Χαρακτηριστικό Αισθητήρα"
          class="ml-8"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="sensorIndexFilter"
          label="Δείκτης Αισθητήρα"
          class="ml-8"
        ></v-text-field> -->

        <!-- <v-text-field
          outline 
          max=30
          v-model="campFilter"
          label="Περιοχή Ευθύνης"
          class="ml-8 mr-8"
        ></v-text-field> -->

        <CampPicker
          :camps="campFilter"
          :clearCampSelTrigger="clearCampSelTrigger"
          ref="campPicker"/>

        </v-row>

        <v-row class="mb-4">
          <v-btn
            color="blue"
            class="text-left ml-12"
            @click="load">
            ΑΝΑΖΗΤΗΣΗ
          </v-btn>

          <v-btn
            class="text-left ml-4"
            @click="resetFilters">
            ΚΑΘΑΡΙΣΜΟΣ ΦΙΛΤΡΩΝ
          </v-btn>
<!-- 
          <v-btn
            color="green"
            class="text-left ml-4"
            @click="downloadEvents">
            ΚΑΤΕΒΑΣΜΑ
          </v-btn> -->

        </v-row>
      </div>
      </template>

      </v-data-table>

    </v-card-text>

  </v-card>
</template>

<script>
import CampPicker from '@/components/CampPicker.vue'

export default {
  name: 'WeatherUpdateManagement',
  props: {
    stationIdFilter: {
      type: String,
      default: "",
      required: false
    },
    hideToolbar: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    CampPicker
  },
  async mounted() {
    const u = this.$store.state.user

    if (!(u.camps && u.camps.length > 0)) {
      return
    }

    if (!(u.isAdmin || u.isCampMaster)) {
      this.campFilter = [u.camps[0]]
      this.$refs.campPicker.selectedCamps = this.campFilter
    }

    this.isAdmin = u.isAdmin

    await this.load()
  },
  data: () => {
    return {
      search: '',
      loading: false,
      campFilter: [],
      updateIdFilter: "",
      fromDateFilter: "",
      toDateFilter: "",
      error: "",
      stationUpdates: [],
      pagination: 15,
      dialog: false,
      isAdmin: false,
      displayNames: {
        //'id': 'Αναγνωριστικό Συμβάντος',
        'stationdescription': 'Περιγραφή',
        //'sensorid': 'Αναγνωριστικό Αισθητήρα',
        'temperature': 'Θερμοκρασία',
        'humidity': 'Υγρασία',
        'pressure': 'Ατμοσφ. Πίεση',
        'windspd': 'Ταχύτητα Ανέμου',
        'winddir': 'Διεύθυνση Ανέμου',
        //'uvrad': 'Υπεριώδης Ακτινοβολία',
        'camp': 'Περιοχή Ευθύνης',
        'timestamp': 'Χρονοσφραγίδα'
      },
      clearCampSelTrigger: 0
    }
  },
  computed: {
    timeOpts:() => {
      return {
          format: "24hr"
      }
    },
    tableHeader() {
      const self = this
      if (!this.stationUpdates || this.stationUpdates.length == 0) {
        return []
      }

      return Object.keys(this.stationUpdates[0])
            .filter(x => Object.keys(self.displayNames).includes(x.toLowerCase()))
            .map(function(x){ 
              return {
                text: self.displayNames[x.toLowerCase()],
                align: 'start',
                sortable: true,
                value: x
              }
            }
          )
    },
    tableData() {
      return this.stationUpdates.map(function(x) {
        var c = Object.assign({}, x)
        
        var dt = new Date(x.timestamp)
        
        dt.setTime(dt.getTime() - (new Date().getTimezoneOffset() * 60 * 1000))
        c.timestamp = dt.toLocaleString('el-GR')

        return c
      })
    }
  },
  methods: {
    goUpdateDetails(value) {
      this.$router.push(`/weatherUpdates/${value.id}`)
    },
    async resetFilters() {
      this.search = ""
      this.campFilter = []
      this.updateIdFilter = ""
      this.stationIdFilter = ""
      this.pagination = 15
      this.clearCampSelTrigger = (this.clearCampSelTrigger+1)%2
      await this.load()
    },
    // async downloadEvents () {
    //   var q = {}

    //   if (this.fromDateFilter !== "" && this.fromDateFilter != null) {
    //     q.fromDate = this.fromDateFilter.toISOString()
    //   }

    //   if (this.toDateFilter !== "" && this.toDateFilter != null) {
    //     q.toDate = this.toDateFilter.toISOString()
    //   }

    //   try{
    //     const response = await this.$axios.get('/sensorEvents/export', {params: {...q} })
    //     const csvContent = "data:text/csv;charset=utf-8," + response.data

    //     var encodedUri = encodeURI(csvContent)

    //     var link = document.createElement("a")
    //     link.hidden = true
    //     link.setAttribute("href", encodedUri)
    //     link.setAttribute("download", "data.csv")
    //     document.body.appendChild(link);
    //     link.click()

    //   } catch (e) {
    //     console.log(e.response)
    //     this.error = e.response.data 
    //   }
    // },
    async load() {
      this.loading = true

      var q = {
        pageSize: -1  // get everything, pagination is handled here anyway
      }

      if (this.fromDateFilter !== "" && this.fromDateFilter != null) {
        q.fromDate = this.fromDateFilter.toISOString()
      }

      if (this.toDateFilter !== "" && this.toDateFilter != null) {
        q.toDate = this.toDateFilter.toISOString()
      }

      if (this.stationIdFilter.trim() !== "") {
        q.stationId = this.stationIdFilter
      }

      if (this.updateIdFilter.trim() !== "") {
        q.updateId = this.updateIdFilter
      }

      this.stationUpdates = []
      const ref_campPicker = this.$refs.campPicker
      for (var selCamp of ref_campPicker.selectedCamps) {
        try{
          q.camp = selCamp
          const response = await this.$axios.get('/weatherUpdates', { params: {...q} })
          this.stationUpdates = this.stationUpdates.concat(response.data)
        } catch (e) {
          console.log(e.response)
          this.error = e.response.data 
        }
      }

      this.loading = false
    },
    /* eslint-disable */
    filter (value, search, _item) {  // _item unused var
    /* eslint-enable */
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search) !== -1
    }
  }
}
</script>
